export default require(`./${process.env.NODE_ENV}`).default;
